<template>
  <div>
    <h5 class="mb-3">{{ $t('vendorPrimarySiteCard.title') }}</h5>
    <b-card class="shadow-sm">
      <b-overlay :show="loading">
        <div v-if="primarySite">
          <div class="d-flex align-items-center flex-wrap">
            <span class="font-size-110 font-weight-500 mr-3">{{ primarySite.display_name }}</span>
            <b-badge
              v-for="siteType in primarySite.site_types"
              :key="siteType.id"
              variant="soft-primary"
              class="mr-1"
              >{{ siteType.name }}</b-badge
            >
          </div>
          <div
            v-if="primarySite.address && primarySite.address.formatted"
            class="text-muted mt-2 d-flex align-items-center"
          >
            <b-icon
              icon="geo-alt-fill"
              class="text-primary-lighter mr-2"
            ></b-icon>
            <span class="mr-2">{{ primarySite.address.formatted }}</span>
            <country-flag
              v-if="primarySite.address.country_code"
              :country="primarySite.address.country_code"
              size="sm"
            ></country-flag>
          </div>
        </div>
        <div
          v-else-if="!loading"
          class="text-muted"
        >
          {{ $t('vendorPrimarySiteCard.noSites') }}
        </div>
        <div
          v-if="siteCount > 1"
          class="text-muted font-size-90 mt-3"
        >
          {{ $t('vendorPrimarySiteCard.moreSites', { count: siteCount - 1 }) }}
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import { errorHandling } from '@/js/custom-vue-mixins';

  // the primary CompanySite on the vendor Summary page -- ONLY for tenants with custom_flags.use_vendor_sites (replaces VendorLocationList there)
  // sites are managed on the Sites tab
  export default {
    name: 'VendorPrimarySiteCard',
    components: {},
    mixins: [errorHandling],
    i18n: {
      messages: {
        en: {
          vendorPrimarySiteCard: {
            title: 'Primary Site',
            noSites: 'No sites yet. Add sites on the Sites tab.',
            moreSites: 'Plus {count} more on the Sites tab',
            errorLoading: 'Error while loading sites',
          },
        },
        es: {
          vendorPrimarySiteCard: {
            title: 'Sitio Principal',
            noSites: 'Aún no hay sitios. Agregue sitios en la pestaña Sitios.',
            moreSites: 'Y {count} más en la pestaña Sitios',
            errorLoading: 'Error al cargar los sitios',
          },
        },
        pt: {
          vendorPrimarySiteCard: {
            title: 'Unidade Principal',
            noSites: 'Ainda não há unidades. Adicione unidades na aba Unidades.',
            moreSites: 'E mais {count} na aba Unidades',
            errorLoading: 'Erro ao carregar as unidades',
          },
        },
        'zh-Hans': {
          vendorPrimarySiteCard: {
            title: '主要站点',
            noSites: '暂无站点。请在“站点”选项卡中添加站点。',
            moreSites: '“站点”选项卡中还有 {count} 个',
            errorLoading: '加载站点时出错',
          },
        },
        'zh-Hant': {
          vendorPrimarySiteCard: {
            title: '主要據點',
            noSites: '尚無據點。請在「據點」分頁中新增據點。',
            moreSites: '「據點」分頁中還有 {count} 個',
            errorLoading: '載入據點時發生錯誤',
          },
        },
      },
    },
    props: {
      companyId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        sites: [],
      };
    },
    computed: {
      primarySite() {
        return this.sites.find((site) => site.is_primary) || null;
      },
      siteCount() {
        return this.sites.length;
      },
    },
    mounted() {
      this.loadSites();
    },
    methods: {
      async loadSites() {
        this.loading = true;
        try {
          const response = await suppliosApi.companySite.list({ params: { company: this.companyId } });
          this.sites = response.data;
        } catch (error) {
          this.errorToaster(error, this.$t('vendorPrimarySiteCard.errorLoading'));
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
